import React from 'react'
import "./AboutIcons.css"
import AboutIconContainer from './AboutIconContainer'

function AboutIcons() {
  return (
    <div className='AboutIcons-container d-flex align-items-center justify-content-evenly gap-4 flex-wrap px-4 standard-padding-space'>
        <AboutIconContainer 
            img={'/images/icons/community.svg'}
            rating={650}
            title={"Our Clients"}
        />
        <AboutIconContainer 
            img={'/images/icons/thumbs.svg'}
            rating={4200}
            extra={"+"}
            title={"Tax Returns Filed"}
        />
        <AboutIconContainer 
            img={'/images/icons/rank.svg'}
            rating={18}
            title={"Years Experience"}
        />
        <AboutIconContainer 
            img={'/images/icons/loop.svg'}
            rating={98.6 }
            extra={"%"}
            title={"Client Retention"}
        />
    </div>
  )
}

export default AboutIcons